import { createFileRoute } from '@tanstack/react-router';
import {
  adminAlertById,
  adminAlertRules,
  adminNotificationChannels,
  copilotStatus,
  pixelsList,
  productionsList,
} from '@/api/resources';
import { warm, warmBackground } from '@/api/loaders';
import { requireSession } from '@/lib/route-guards';
import { parseBackendAlertSearch } from '@/lib/backend-alert-search';
import { useSetViewShim } from '@/lib/use-set-view';
import { AlertsScreen } from '@/screens/backend-alerts';

export const Route = createFileRoute('/backend/alerts')({
  validateSearch: parseBackendAlertSearch,
  loaderDeps: ({ search }) => ({ incident: search.incident }),
  // Search-driven route: no skeleton for an in-screen navigation (router.ts).
  pendingMs: Infinity,
  beforeLoad: requireSession,
  // The pickers block; configuration-backed rules, channels, and Copilot gate
  // warm behind them. Triggered alerts and health bands remain poll-driven.
  loader: ({ context, deps }) => {
    warmBackground(
      context.queryClient,
      adminAlertRules(undefined),
      adminNotificationChannels(undefined),
      copilotStatus(undefined),
    );
    if (deps?.incident) {
      // Realtime resources are born stale, so this must remain background
      // work. The selected-incident panel owns its loading state.
      warmBackground(context.queryClient, adminAlertById(deps.incident));
    }
    return warm(context.queryClient, pixelsList({}), productionsList({}));
  },
  component: Page,
});

function Page() {
  useSetViewShim();
  const { incident } = Route.useSearch();
  return <AlertsScreen incidentId={incident} />;
}
